import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';
import clsx from 'clsx';

import { WithRef } from '../../types';
import { mergeSx, createSelectorSx } from '../../utils';

export type TooltipProps = MuiTooltipProps & {
  size?: 'small' | 'medium';
  testId?: string;
  wrapIf?: boolean;
  offset?: number;
};

export const Tooltip = ({
  ref,
  children,
  color = 'primary',
  size = 'medium',
  className,
  PopperProps = {},
  sx,
  title,
  wrapIf = true,
  testId,
  offset = -4,
  ...props
}: WithRef<unknown, TooltipProps>) => {
  if (testId) {
    (PopperProps as any)['data-testid'] = testId;
  }
  if (!wrapIf) {
    return children;
  }
  return (
    <MuiTooltip
      arrow
      {...props}
      PopperProps={{
        ...PopperProps,
        sx: mergeSx(
          PopperProps?.sx,
          sx && createSelectorSx('& .MuiTooltip-tooltip', sx)
        ),
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, offset],
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          className: clsx(
            className,
            `DS-Tooltip-color-${color}`,
            `DS-Tooltip-size-${size}`
          ),
        },
      }}
      title={title}
      ref={ref}
    >
      {children}
    </MuiTooltip>
  );
};

Tooltip.displayName = 'Tooltip';
